require("./heatmap/HeatmapSeries");

require("./heatmap/HeatmapView");


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/chart/heatmap.js
// module id = 2271
// module chunks = 0